/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Badge } from '@chakra-ui/react';
import { useMemo } from 'react';
import useStore from '../../store';
import { useDebounceEffect } from '../form/useDebounceEffect';

const QUERY_COUNT = gql`
	query {
		getCountCompanySaleProfessionalNewRequest
		getCountCompanySaleProfessionalTerminationRequest
	}
`;

function InsuranceCompanySaleStaffBadge() {
	const { countUnreadNotifications } = useStore((state) => state?.countUnreadNotifications);
	const { currentUser } = useStore((state) => state.currentUser);
	const [loadCount, { data }] = useLazyQuery(QUERY_COUNT);

	useDebounceEffect(loadCount, 200, [countUnreadNotifications]);

	const count = useMemo(() => {
		if (data?.getCountCompanySaleProfessionalNewRequest && data?.getCountCompanySaleProfessionalTerminationRequest) {
			if (parseInt(currentUser?.position) >= 5) {
				let val = 0;
				if (data?.getCountCompanySaleProfessionalNewRequest) {
					const tempNew = JSON.parse(data?.getCountCompanySaleProfessionalNewRequest);
					val = val + tempNew?.reviewingByOffice;
				}
				if (data?.getCountCompanySaleProfessionalTerminationRequest) {
					const tempTerminate = JSON.parse(data?.getCountCompanySaleProfessionalTerminationRequest);
					val = val + tempTerminate?.reviewingByOffice;
				}
				return val;
			}
			if (parseInt(currentUser?.position) <= 4) {
				let val = 0;
				if (data?.getCountCompanySaleProfessionalNewRequest) {
					const tempNew = JSON.parse(data?.getCountCompanySaleProfessionalNewRequest);
					val = val + tempNew?.reviewingByDepartment;
				}
				return val;
			}
		}
		return 0;
	}, [data]);

	return (
		<>
			{parseInt(count) > 0 && (
				<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
					{parseInt(count)}
				</Badge>
			)}
		</>
	);
}

export default InsuranceCompanySaleStaffBadge;
